import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('HotelDescriptionModel')
export default class HotelDescriptionModel {
  @JsonProperty('title', String) public title:string = '';
  @JsonProperty('paragraph', String) public paragraph:string = '';
}
